import React, {useEffect,  useState} from "react";
import {GetAuth} from "../../utils/Verbs";
import {useDebouncedApiCall, useInterval, useTitleFromComponent} from "../../utils/hooks";
import { useVsiAppContext} from "../../stores/VsiApp";
import { VsiH4, VsiH6, VsiHr} from "../../styled/App.styled";
import Grid from "../../components/Grid";
import {allUploadDefs} from "../../utils/gridColumnDefs/admin/uploads";
import {useAuthWithRoute} from "../../utils/hooks";

export default function AllUploads({title}) {
    useTitleFromComponent(title);
    const { getAccessTokenSilently } = useVsiAppContext();
    const [allUploads, setAllUploads] = useState([]);
    // const [updated, setUpdated] = useState(false);

    const [timeInterval, setTimeInterval] = useState(5000);


    useEffect(() => {
        getUploads();
        fetchData();
    }, []);

    const [debouncedCallback] = useDebouncedApiCall(() => {
        getUploads();
        reFetchData();
    }, 500);

    useInterval(debouncedCallback, timeInterval);

    const getUploads = async () => {
      const token = await getAccessTokenSilently();
        GetAuth("/api/v6/admin/all-uploads", token)
            .then(data => {
                let updData = data.data.uploads.map(datum => {
                    return {
                        ...datum,
                        uploadedBy: datum.uploadedBy,
                        clientName: datum.clientName?.[0]?.name || ' '
                    }
                });
                setAllUploads(updData);
            })
            .catch(err => {
                console.error(err);
            });
    };

    const [queueData, {fetchData, reFetchData}] = useAuthWithRoute("/api/v6/upload/queue");

    return (
        <div>
            <VsiH4>All Uploads</VsiH4>
            <VsiHr/>
            <VsiH6>Enqueued: {queueData.messages}</VsiH6>
            <Grid
                data={allUploads}
                height={1200}
                columnDefs={allUploadDefs}
                autoSizeStrategy={{
                    type: 'fitCellContents',
                }}
            />
        </div>
    )
}

